import { useMemo } from 'react'

import { sub } from 'date-fns'
import DatePicker from 'material/DatePicker'

import useIsShadow from 'common/use-is-shadow'

import { useFocusedApplicationCycle } from '../AppRoundProvider'
import { useAppCycleEndDate, useAppCycleStartDate } from './app-round-helper'

const getMinDate = (roundDeadline?: string, fallback?: Date) => (roundDeadline ? new Date(roundDeadline) : fallback)
const getMaxDate = (maxDate: Date, materialsDeadline?: string) =>
  materialsDeadline ? new Date(materialsDeadline) : maxDate

type CutOffDatePickerProps = {
  onUpdate: (update: string) => void
  onError: (error?: React.ReactElement) => void
  deadline?: string
  cutoff?: string
  materialsDeadline?: string
}

const CutoffDatePicker = ({ onUpdate, deadline, cutoff, materialsDeadline, onError }: CutOffDatePickerProps) => {
  const yesterday = useMemo(() => sub(new Date(), { days: 1 }), [])
  const isShadow = useIsShadow()
  const applicationCycle = useFocusedApplicationCycle()
  const maxAppRoundDate = useAppCycleEndDate(applicationCycle)
  const fallback = useAppCycleStartDate(applicationCycle)
  const minDate = useMemo(() => getMinDate(deadline, fallback), [deadline, fallback])
  const maxDate = useMemo(() => getMaxDate(maxAppRoundDate, materialsDeadline), [materialsDeadline, maxAppRoundDate])
  return (
    <DatePicker
      required
      fullWidth
      date={cutoff}
      onError={onError}
      onChange={onUpdate}
      FormHelperTextProps={{ role: 'alert' }}
      autoOk
      label="Cutoff Date"
      format="MM/dd/yyyy"
      minDateMessage={
        isShadow
          ? 'The cut-off date cannot precede the round deadline nor yesterday'
          : 'The cut-off date cannot precede today nor the round deadline'
      }
      maxDateMessage="Date cannot be after July 31 of the academic year or the materials deadline"
      invalidDateMessage="Must be formatted to MM/DD/YYYY"
      disablePast={!isShadow}
      minDate={isShadow ? yesterday : minDate}
      maxDate={maxDate}
      id="cutoff-date"
    />
  )
}

export default CutoffDatePicker
